import CustomSelect from 'Common/CustomSelect';
import LoaderWrapper from 'Common/LoaderWrapper/LoaderWrapper';
import Show from 'Components/Show/Show'
import api from 'http';
import React, { useEffect, useState } from 'react'
import { ErrorHandlingMessage } from 'Utils/ErrorHandlingMessage';

const CardReaderPaymentMethod = ({ paymentModel, handlePaymentMethod }) => {
    const [cardReaders, setCardReaders] = useState([]);
    const [cardReaderLoader, setCardReaderLoader] = useState(false);

    useEffect(() => {
        if (paymentModel.stripeSettingsId && paymentModel.patientPaymentType === 'CC_RDR') {
            (async () => {
                try {
                    setCardReaderLoader(true);
                    let res = await api.get(`${process.env.REACT_APP_TC_PMS}/api/PatientPayment/FindTerminalReaders/${paymentModel.stripeSettingsId}`,);
                    setCardReaders(res.data.dataModel);
                } catch (error) {
                    ErrorHandlingMessage(error);
                } finally {
                    setCardReaderLoader(false);
                }
            })();
        }
    }, [paymentModel.stripeSettingsId, paymentModel.patientPaymentType])
    return (
        <div>
            <div className="flex items-center">
                <input type="radio" id="CC_RDR" name="patientPaymentType" value="CC_RDR" checked={paymentModel.patientPaymentType === 'CC_RDR'} onChange={handlePaymentMethod} className="w-4 h-4 text-blue-600 focus:ring-blue-500" />
                <label htmlFor="CC_RDR" className="ml-3 text-sm text-slate-700">Pay via Card Reader</label>
            </div>
            <Show when={paymentModel.patientPaymentType === 'CC_RDR'}>
                <div className="mt-2 ml-7">
                    <LoaderWrapper loading={cardReaderLoader} className="h-[38px]">
                        <CustomSelect name="terminalId" value={paymentModel.terminalId} onChange={handlePaymentMethod} >
                            <option value="">Please Select</option>
                            {cardReaders.map((reader) => (
                                <option
                                    key={reader.readerId}
                                    value={reader.readerId}
                                    style={{ color: reader.status === 'online' ? 'green' : 'red' }}
                                >
                                    {reader.readerLabel} - ({reader.status})
                                </option>
                            ))}
                        </CustomSelect>
                    </LoaderWrapper>
                </div>
            </Show>
        </div>
    )
}

export default CardReaderPaymentMethod